import { render, staticRenderFns } from "./electricityRecord.vue?vue&type=template&id=24f42cf6&scoped=true"
import script from "./electricityRecord.vue?vue&type=script&lang=js"
export * from "./electricityRecord.vue?vue&type=script&lang=js"
import style0 from "./electricityRecord.vue?vue&type=style&index=0&id=24f42cf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f42cf6",
  null
  
)

export default component.exports